import { gql } from '@apollo/client';

export type LateAddToCartUserEligibilityQueryResult = {
  getLateAddToCartUserEligibility: {
    isEligible: boolean;
  };
};

export const GET_LATE_ADD_TO_CART_USER_ELIGIBILITY = gql`
  query GetLateAddToCartUserEligibility {
    getLateAddToCartUserEligibility {
      isEligible
    }
  }
`;
